import { formatCurrency } from '@/common/utils/formatters'
import { PriceSurveyData } from '@/features/priceSurvey/types/priceSurvey.type'

export class PriceSurveyProductsTransformer {
  static tableTransformer() {
    return (priceSurveyProducts: PriceSurveyData['price_survey_products']) => {
      return priceSurveyProducts.map((priceSurveyProduct) => ({
        ...priceSurveyProduct,
        display_name: priceSurveyProduct.product.display_name,
        price: priceSurveyProduct.price ? formatCurrency(Number(priceSurveyProduct.price)) : '',
      }))
    }
  }
}
